export default __webpack_public_path__ + "static/media/produk 2.6deeb5fb.png";